export default [
  {
    title: 'Resources',
    // icon: 'PackageIcon',
    icon: 'bulb',
    children: [
      {
        title: 'Overview',
        route: 'resources',
      },
    ],
  },
]
